module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cc-user-kombox-form"
  }, [_c('form', {
    attrs: {
      "id": _vm._uid
    },
    on: {
      "focusout": _vm.isFormBlur,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('cancel', _vm.kombox)
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onExit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 text-right",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.type),
      expression: "editKombox.type"
    }],
    staticClass: "form-control text-right",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editKombox, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n          " + _vm._s(option.text) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.content),
      expression: "editKombox.content"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "pattern": _vm.KomboxConf.TYPES[_vm.editKombox.type].CONTENT.PATTERN,
      "placeholder": _vm.KomboxConf.TYPES[_vm.editKombox.type].CONTENT.PLACEHOLDER,
      "title": _vm.KomboxConf.TYPES[_vm.editKombox.type].CONTENT.PLACEHOLDER
    },
    domProps: {
      "value": (_vm.editKombox.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editKombox, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.description),
      expression: "editKombox.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "privat, office ..."
    },
    domProps: {
      "value": (_vm.editKombox.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editKombox, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 text-right",
    staticStyle: {
      "padding": "0px"
    }
  }, [(_vm.editKombox.content) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "form": _vm._uid
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "submit",
      "form": _vm._uid
    },
    on: {
      "click": _vm.onClickTrash
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0d07fae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/KomboxForm.vue
// module id = 289
// module chunks = 0